import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const ARVRDevelopmentPage: React.FC = () => {
  return <ServicePageTemplate slug="ar-vr-development" />;
};

export default ARVRDevelopmentPage;
